module.exports = __webpack_public_path__ + "static/media/СЗФО_2005.b8af9df2.png";